import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { tokens } from "@trustpilot/design-tokens";
import { zIndexLevels } from "../../internalConstants";
export var modalSizes = {
  small: 392,
  medium: 576,
  "default": 576,
  large: 760,
  "x-large": 1024
};
export var backdropStyles = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  // append 50% opacity (80 in hex) to the backdrop color.
  background: "".concat(tokens.colorSemanticSurfaceForegroundDefault, "80"),
  zIndex: zIndexLevels.modalBackdrop,
  willChange: "opacity"
};
export var baseModalStyles = {
  width: "100%",
  left: "50%",
  maxHeight: "100%",
  background: "var(--CDS-color-semantic-surface-default)",
  borderRadius: "var(--CDS-border-radius-l)",
  zIndex: zIndexLevels.modalContent,
  top: "50%",
  transform: "translate(-50%, -50%)"
};
export var fullscreenModalStyles = _objectSpread(_objectSpread({}, baseModalStyles), {}, {
  height: ["100%", null, "auto"],
  borderRadius: [0, null, "var(--CDS-border-radius-l)"]
});
export var baseDrawerStyles = _objectSpread(_objectSpread({}, baseModalStyles), {}, {
  top: "0",
  height: "100%",
  right: "0",
  left: "auto",
  borderTopRightRadius: "0",
  borderBottomRightRadius: "0",
  display: "flex",
  flexDirection: "column"
});
export var fullscreenDrawerStyles = _objectSpread(_objectSpread({}, baseDrawerStyles), {}, {
  borderTopLeftRadius: [0, null, "var(--CDS-border-radius-l)"],
  borderBottomLeftRadius: [0, null, "var(--CDS-border-radius-l)"]
});
export var modalAnimationVariants = {
  hidden: {
    opacity: 0,
    x: "-50%",
    y: "-100%"
  },
  visible: {
    opacity: 1,
    x: "-50%",
    y: "-50%"
  }
};
export var drawerModalAnimationVariants = {
  hidden: {
    opacity: 0,
    x: "100%"
  },
  visible: {
    opacity: 1,
    x: "0%",
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};
export var backdropAnimationVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1
  }
};
export var contentStyles = {
  boxSizing: "border-box",
  display: "block",
  overflowY: "auto"
};
export var footerStyles = {
  boxSizing: "border-box",
  display: "flex",
  flexShrink: 0,
  width: "100%",
  borderTop: "solid 1px var(--CDS-color-semantic-border-default)",
  padding: "var(--CDS-spacing-m)"
};
export var closeButtonStyles = {
  background: "none",
  margin: 0,
  /**
   * Circle for the X button has been added here, through
   * padding, border, and border-radius. Ideally we would
   * have a IconButton component, like we do in the CPL.
   */
  padding: "7px",
  border: "1px solid var(--CDS-color-semantic-actions-default)",
  borderRadius: "50%",
  color: "var(--CDS-color-semantic-actions-default)",
  lineHeight: 0,
  height: "auto",
  "&:hover, &:focus": {
    background: "none",
    outline: "none",
    color: "var(--CDS-color-semantic-actions-default)",
    cursor: "pointer"
  },
  "&.focus-visible": {
    background: "none",
    borderRadius: "50%",
    outline: "2px solid var(--CDS-color-semantic-actions-default)",
    outlineOffset: "2px"
  }
};